import { render, staticRenderFns } from "./UpdateRequirements.vue?vue&type=template&id=4057cde0&scoped=true&"
import script from "./UpdateRequirements.vue?vue&type=script&lang=js&"
export * from "./UpdateRequirements.vue?vue&type=script&lang=js&"
import style0 from "./UpdateRequirements.vue?vue&type=style&index=0&id=4057cde0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4057cde0",
  null
  
)

export default component.exports